import { render } from "./ExtendedResources.vue?vue&type=template&id=2d896acd&scoped=true"
import script from "./ExtendedResources.vue?vue&type=script&lang=js"
export * from "./ExtendedResources.vue?vue&type=script&lang=js"

import "./ExtendedResources.vue?vue&type=style&index=0&id=2d896acd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d896acd"

export default script